import { OptionRight, TradingClass, TrendLine } from '../../types/entities';
import { SecurityCategory, SecuritySector } from '../../types/enums';
import { ContractDetails } from '../../types/tws-entities';

export interface UserSettingsState {
  useFrozen: boolean;
  showSummary: boolean;
  useSnapshot: boolean;
  cashOverviewCollapsed: boolean;
  regimeAnalyticsCollapsed: boolean;
  newsPanelCollapsed: boolean;
  indicatorPanelCollapsed: boolean;
  hourGraphCollapsed: boolean;
  dailyGraphCollapsed: boolean;
  selectedSecurityCategory: SecurityCategory;
  selectedSecurityId: string | undefined;
  selectedSecuritySector: SecuritySector | undefined;
  selectedContractDetails?: ContractDetails | undefined;
  securityPanelCollapsed: boolean;
  trendLinesCollapsed: boolean;
  shortListCollapsed: boolean;
  securityPresetsCollapsed: boolean;
  quickNotesCollapsed: boolean;
  ladderSetupCollapsed: boolean;
  legStateCollapsed: boolean;
  strategyCollapsed: boolean;
  strategyLogsCollapsed: boolean;
  strategyLegsCollapsed: boolean;
  betaSummaryCollapsed: boolean;
  strategyFeaturesCollapsed: boolean;
  overtakeStrategyFeaturesCollapsed: boolean;
  pursuitStrategyFeaturesCollapsed: boolean;
  chicaneStrategyFeaturesCollapsed: boolean;
  pitlaneEntryGatesCollapsed: boolean;
  pitlaneRiskManagementCollapsed: boolean;
  displayPreferencesCollapsed: boolean;
  skewEntryCollapsed: boolean;
  zScoreEntryCollapsed: boolean;
  redlineRacingCollapsed: boolean;
  redlineCorrectionCollapsed: boolean;
  microHarvestCollapsed: boolean;
  openingHoursCollapsed: boolean;
  positionTimeoutCollapsed: boolean;
  stopLossCollapsed: boolean;
  doubleUpCollapsed: boolean;
  trailingStopCollapsed: boolean;
  profitTargetCollapsed: boolean;
  racingTeCollapsed: boolean;
  trendEfficiencyEntryCollapsed: boolean;
  raceCarCollapsed: boolean;
  entryCollapsed: boolean;
  drawdownExitCollapsed: boolean;
  hardExitCollapsed: boolean;
  selectedContractSection: 'all-contracts' | 'front-runners';
  selectedBackOfficeTab: 'securities' | 'portfolios' | 'fundamentals';
  selectedDashboardTab: 'active' | 'archived';
  selectedSecurityTab: string;
  selectedSpreadSettingsTab: string;
  selectedWatchlistTab: string;
  selectedHistoryTab: string;
  selectedTrendLine?: TrendLine | undefined;
  selectedSector: SecuritySector;
  optionSettings: {
    [symbol: string]: {
      selectedTradingClass: TradingClass | undefined;
      selectedRight: OptionRight;
    };
  };
  historyYear: number;
  historyMonth: number;
}

const now = new Date();
const yearNow = now.getFullYear();

export const initialState: UserSettingsState = {
  useFrozen: false,
  showSummary: false,
  useSnapshot: false,
  cashOverviewCollapsed: true,
  regimeAnalyticsCollapsed: true,
  newsPanelCollapsed: false,
  indicatorPanelCollapsed: false,
  hourGraphCollapsed: false,
  dailyGraphCollapsed: false,
  selectedSecurityCategory: SecurityCategory.Shortlist,
  selectedSecurityId: undefined,
  selectedSecuritySector: undefined,
  securityPanelCollapsed: true,
  trendLinesCollapsed: false,
  shortListCollapsed: false,
  securityPresetsCollapsed: true,
  quickNotesCollapsed: false,
  ladderSetupCollapsed: false,
  legStateCollapsed: true,
  strategyCollapsed: false,
  strategyLogsCollapsed: false,
  strategyLegsCollapsed: false,
  betaSummaryCollapsed: false,
  strategyFeaturesCollapsed: false,
  overtakeStrategyFeaturesCollapsed: false,
  pursuitStrategyFeaturesCollapsed: false,
  chicaneStrategyFeaturesCollapsed: false,
  pitlaneEntryGatesCollapsed: false,
  pitlaneRiskManagementCollapsed: false,
  displayPreferencesCollapsed: true,
  skewEntryCollapsed: true,
  zScoreEntryCollapsed: true,
  redlineRacingCollapsed: true,
  redlineCorrectionCollapsed: true,
  microHarvestCollapsed: true,
  openingHoursCollapsed: true,
  positionTimeoutCollapsed: true,
  stopLossCollapsed: true,
  doubleUpCollapsed: true,
  trailingStopCollapsed: true,
  profitTargetCollapsed: true,
  trendEfficiencyEntryCollapsed: true,
  racingTeCollapsed: true,
  raceCarCollapsed: true,
  entryCollapsed: true,
  drawdownExitCollapsed: true,
  hardExitCollapsed: true,
  selectedContractSection: 'all-contracts',
  selectedBackOfficeTab: 'securities',
  selectedDashboardTab: 'active',
  selectedSecurityTab: 'general',
  selectedSpreadSettingsTab: 'general',
  selectedWatchlistTab: 'news',
  selectedHistoryTab: 'recent',
  selectedSector: SecuritySector.Indexes,
  optionSettings: {},
  historyYear: yearNow,
  historyMonth: now.getMonth() + 1
};
